(function ($) {

  /*
   * common functions
   */
  let pcWindow, spWindow;
  if (767 < $(window).outerWidth()) {
    pcWindow = true;
    spWindow = false;
  } else {
    pcWindow = false;
    spWindow = true;
  }

  // nav settings
  $('.btn-nav').on('click', () => {
    $('.btn-nav').toggleClass('opened');
    $('.nav-wrapper').toggleClass('opened');
  });

  $('.nav-wrapper').on('click', () => {
    $('.btn-nav').removeClass('opened');
    $('.nav-wrapper').removeClass('opened');
  });

  $('.nav-list li a').on('click', function (e) {
    e.stopPropagation();
  });

  // play video
  $('.video-overlay').on('click', function() {
    const $youtubeVideo = $(this).hide().next('iframe')[0].contentWindow;
    $youtubeVideo.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
  });

  $(window).on({
    'load': function () {
      const $fadeInAnimations = $('.fade-in-animation');
      const $displayedFadeInAnimationList = $fadeInAnimations.map((ci, ce) => {
        if ($(ce).offset().top < $(window).outerHeight()) return ce;
      });
      $displayedFadeInAnimationList.each((ci, ce) => {
        const _ci = ci;
        setTimeout(() => { $(ce).addClass('show'); }, 200 * _ci);
      });
    },
    'scroll': function () {
      // animation settings
      var windowScroll = $(window).scrollTop();
      var appearPoint = windowScroll + $(window).outerHeight();
      $(".fade-in-animation, .add-animation").each(function () {
        var thisOffset = $(this).offset().top;
        if (thisOffset < appearPoint) $(this).addClass("show");
      });
      // header settings
      const currentScroll = $(window).scrollTop();
      if (currentScroll === 0) {
        $('#header').removeClass('moved');
      } else {
        $('#header').addClass('moved');
      }
    },
  });

  /*
   * index page
   */
  if ($('#page-index')[0]) {
    // first animation
    const showImgGround = () => {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve($('.bg-img div').eq(0).addClass('show'));
        }, 200);
      });
    };

    const showImgTree = () => {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve($('.bg-img div').eq(1).addClass('show'));
        }, 1600);
      });
    };

    const showLinkSangaku = () => {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve($('.page-content .link-sangaku').addClass('show'));
        }, 1600);
      });
    };

    const showLinkCircle = () => {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve($('.page-content .link-middle, .page-content .link-small').addClass('show'));
        }, 300);
      });
    };

    const showLinkCloud = () => {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve($('.page-content .link-cloud, .page-content .img-bird').addClass('show'));
        }, 300);
      });
    };

    $(window).on({
      'load': function () {
        // init animation
        const promise = Promise.resolve();
        promise
          .then(showImgGround)
          .then(showImgTree)
          .then(showLinkSangaku)
          .then(showLinkCircle)
          .then(showLinkCloud)
      },
    });
  }

  /*
   * top page
   */
  if ($('#page-top')[0]) {

    // section-head animation
    const setScrollTopZero = () => {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve($('html, body').scrollTop(0));
        }, 50);
      });
    };

    const showTitleArea = () => {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve($('.section-head .title-area').addClass('show'));
        }, 200);
      });
    };

    const showHeader = () => {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve($('.page-top-header').addClass('show'));
        }, 4200);
      });
    };

    const removeWrap = () => {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve($('#page-top').addClass('no-wrap'));
        }, 1200);
      });
    };

    $(window).on({
      'load': function () {
        // init animation
        if (!location.hash) {
          const promise = Promise.resolve();
          promise
            .then(setScrollTopZero)
            .then(showTitleArea)
            .then(showHeader)
            .then(removeWrap)
        } else {
          $('.section-head .title-area').addClass('show');
          $('.page-top-header').addClass('show');
          $('#page-top').addClass('no-wrap');
          if (spWindow && location.hash == '#partner') {
            const diff = 60 * $(window).outerWidth() / 375;
            $('body, html').scrollTop($('#partner').offset().top - diff);
          }
         }
      },
    });

    // coordinator rotation
    const $coordinatorList = $('.coordinator-list li');
    let currentIndex = 0;
    let startTime = null;
    const update = function(timestamp) {
      if (!startTime) startTime = timestamp;
      const progress = timestamp - startTime;
      if (5000 < progress) {
        startTime = timestamp;
        $coordinatorList.eq(currentIndex).animate({'opacity': 0}, 1200, 'linear');
        (currentIndex < $coordinatorList.length - 1) ? currentIndex++ : currentIndex = 0;
        setTimeout(() => {
          $coordinatorList.eq(currentIndex).animate({'opacity': 1}, 1200, 'linear');
        }, 400);
      }
      window.requestAnimationFrame(update);
    };
    update();

    // parallax animation
    (function() {
      var sleepTime = 200; // スクロール慣性
      var initTime = Date.now();
      var currentSlide = 0;
      var touchDevise = false;
      var parallaxSize = 950;
      var parallaxAnimationDuration = 800; // パララックススピード
      var animationFlag = true;
      var $sections = $('.section-head, section, footer');

      var currentTime;
      var startY;
      var prevY;
      var variation = 0;

      if (pcWindow) {

        $(window).on('load', function (e){
          if (location.hash) {
            const hash = location.hash;
            switch (hash) {
              case '#about':
                currentSlide = 2; break;
              case '#research':
                currentSlide = 3; break;
              case '#event':
                currentSlide = 4; break;
              case '#partner':
                currentSlide = 4; break;
              case '#newsletter':
                currentSlide = 5; break;
              default:
                currentSlide = 0; break;
            }
            $(".section-" + hash.slice(1) + " .add-animation").each(function () {
              setTimeout(() => {
                $(this).addClass("show");
              }, 800);
            });
          }
        });

        $( function() {
          if (location.hash) {
            const hash = location.hash;
            if (hash == '#partner') {
              $('body, html').scrollTop($('#event').offset().top);
            }
          }
        });

        $(window).on('touchstart', function (e){
          touchDevise = true;
          startY = e.originalEvent.touches[0].clientY;
          prevY = startY;
        });

        $(window).on('wheel touchmove', function (e) {
          if (animationFlag) {
            if (typeof e.changedTouches === 'undefined') touchDevise = false;
            var deltaY = touchDevise ? prevY - e.changedTouches[0].clientY : e.originalEvent.deltaY;
            if (!deltaY) return;

            currentTime = Date.now();

            var maxDiff = parallaxSize - $(window).outerHeight();
            variation -= deltaY;
            variation = Math.min(variation, 0);
            variation = Math.max(-maxDiff, variation);

            if ((0 < deltaY) && (currentTime - initTime) > sleepTime) {
              // 下にパララックスする際の処理
              if ($sections.length - 1 == currentSlide) return;
              slideParallax(deltaY);
            } else if ((deltaY < 0) && (currentTime - initTime) > sleepTime) {
              // 上にパララックスする際の処理
              if (currentSlide == 0) return;
              slideParallax(deltaY);
            }
          }
        });
      }

      // nav link integration
      $('.nav-list li a').on('click', function(e) {
        const indexPosition = $(this).data('index-position');
        if (indexPosition != null) {
          e.preventDefault();
          $('.btn-nav, .nav-wrapper').removeClass('opened');
          currentSlide = indexPosition;
          if (~$(this).attr('href').indexOf('partner') && spWindow) {
            const diff = 60 * $(window).outerWidth() / 375;
            $('body, html').animate({ scrollTop: $('#partner').offset().top - diff}, 400, 'easeOutCubic');
          } else {
            $('body, html').animate({scrollTop: $sections.eq(currentSlide).offset().top}, 400, 'easeOutCubic');
          }
          // 背景のブロックを動かす処理
          const maxSlideWidth = 84;
          $('.object-1').css('right', -Math.min(maxSlideWidth, maxSlideWidth / 5 * currentSlide));
        }
      });

      function slideParallax(direction) {
        animationFlag = false;
        setTimeout(function () {
          animationFlag = true;
          initTime = Date.now();
        }, parallaxAnimationDuration + 20);
        (0 < direction) ? currentSlide++ : currentSlide-- ;
        $sections = $('.section-head, section, footer');
        $('body, html').animate({scrollTop: $sections.eq(currentSlide).offset().top}, 600, 'easeOutCubic');
        // 背景のブロックを動かす処理
        const maxSlideWidth = 84;
        $('.object-1').css('right', -Math.min(maxSlideWidth, maxSlideWidth / 5 * currentSlide));
      }
    }());
  }

  /*
   * research archive page
   */
  if ($('#page-research-archive')[0]) {
    if (location.hash && pcWindow) {
      const hash = location.hash;
      if ($(hash)[0]) {
        const targetOffsetTop = $(hash).offset().top;
        const targetHeight = $(hash).outerHeight();
        const windowHeight = $(window).outerHeight();
        const targetPosition = targetOffsetTop - (windowHeight - targetHeight) / 2;
        $('body, html').scrollTop(targetPosition);
        $(hash).find('.fade-in-animation').addClass('show');
      }
    }
  }

  jQuery.extend(jQuery.easing, {
    easeOutCubic: function (x, t, b, c, d) {
      return c * ((t = t / d - 1) * t * t + 1) + b;
    },
  });

}(jQuery));